/**
 * Product image tile. Cycles through up to 3 images on hover:
 *   • primary image (front) is always visible
 *   • on hover, cross-fades to `hoverSrcs[0]` (back) after 0.4s, then `hoverSrcs[1]` (side) after 1.5s
 * No emblem overlay — the LOOXS emblem lives on the physical garment
 * (embroidered / debossed / etched) and inside each product image itself.
 */
import { useEffect, useState } from "react";

export default function ProductImageTile({
  src,
  hoverSrc,        // legacy — 2nd image
  hoverSrcs,       // preferred — array of extra images beyond the primary
  alt = "",
  className = "",
}) {
  const extras = (hoverSrcs && hoverSrcs.length)
    ? hoverSrcs.filter(u => u && u !== src)
    : (hoverSrc && hoverSrc !== src ? [hoverSrc] : []);
  const frames = [src, ...extras];              // 1..3 images
  const [i, setI] = useState(0);
  const [hover, setHover] = useState(false);
  useEffect(() => {
    if (!hover || frames.length < 2) { setI(0); return; }
    let step = 1;
    const timers = [];
    for (const f of frames.slice(1)) {
      timers.push(setTimeout(() => setI(step++), (timers.length + 1) * 1100));
    }
    return () => timers.forEach(clearTimeout);
  }, [hover, frames.length]);
  return (
    <div
      className={`relative aspect-[3/4] bg-parchment overflow-hidden hover-shift ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {frames.map((u, idx) => (
        <img
          key={u + idx}
          src={u}
          alt={idx === 0 ? alt : ""}
          draggable="false"
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700"
          style={{ opacity: idx === i ? 1 : 0 }}
        />
      ))}
    </div>
  );
}
